import React, { useContext, FC } from "react";
import { ProductContext } from "../../contexts/product/Store";
import { HistoryContext } from "../../contexts/history/Store";
import { FlatList } from "react-native";
import { IProduct } from "../../interfaces/product";
import ProductStack from "./ProductStack";
import NextPageLoaderGeneric from "../common/NextPageLoaderGeneric";
import ProductListHeader from "./ProductListHeader";

interface ISectionProps {
  _id: number;
  type: "header" | "body";
  data?: string | IProduct[];
  component?: FC;
  count?: number;
}

const HomeScreenProductListing: FC = () => {
  const { product_state, fetch_next_product } = useContext(ProductContext);
  const [history_state] = useContext(HistoryContext);

  const Section: React.FC<{ item: ISectionProps }> = ({ item }) => {
    return (
      <>
        {item.type === "header" ? (
          <ProductListHeader
            title={item.data}
            count={item.count}
            isLoading={false}
          />
        ) : (
          <item.component />
        )}
      </>
    );
  };

  const AllProductStack = () => {
    return (
      <ProductStack
        title={`All products`}
        products={product_state.all_products}
        isLoading={
          !product_state.all_products.length &&
          product_state.loading_next_product
        }
        showHeading={false}
      />
    );
  };

  const HistoryProductStack = () => {
    return (
      <ProductStack
        title={`Recently purchased`}
        products={history_state.product_history}
        isLoading={
          !product_state.all_products.length &&
          product_state.loading_next_product
        }
        showHeading={false}
      />
    );
  };

  return (
    <FlatList
      keyExtractor={({ _id }) => _id}
      data={[
        {
          _id: "0",
          type: "header",
          data: "Recently purchased",
          count: history_state.product_history.length,
        },
        {
          _id: "1",
          type: "body",
          component: HistoryProductStack,
        },
        {
          _id: "2",
          type: "header",
          data: "All Products",
          count: product_state.all_products.length,
        },
        {
          _id: "3",
          type: "body",
          component: AllProductStack,
        },
      ]}
      renderItem={({ item }) => <Section item={item} />}
      stickyHeaderIndices={[0, 2]}
      ListFooterComponent={() => (
        <NextPageLoaderGeneric
          loading={product_state.loading_next_product}
          page={product_state.product_page}
          total={product_state.product_page_total}
          action={fetch_next_product}
        />
      )}
      onEndReached={() => {
        !product_state.loading_next_product && fetch_next_product();
      }}
      onEndReachedThreshold={2}
    />
  );
};

export default HomeScreenProductListing;
